import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme) => ({
	sbDatePickerBaseHeader: {
		textAlign: "center",
		textTransform: "uppercase",
		fontSize: "10px !important",
	},
}));
